export let snooze = "sEXEIc";
export default {snooze};